export interface ArticleContent {
  id: number;
  title: string;
  author: string;
  category: string;
  coverImage: string;
  rating: number;
  status: string;
  views: number;
  updateDate: string;
  publishDate: string;
  tags: string[];
  summary: string;
  sections: ArticleSection[];
  faqs: FAQ[];
}

export interface ArticleSection {
  heading: string;
  content: string;
}

export interface FAQ {
  question: string;
  answer: string;
}

export const articleContents: Record<number, ArticleContent> = {
  1: {
    id: 1,
    title: "她的秘密花园",
    author: "金智媛",
    category: "romance",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20style%20artwork%20romance%20cover%2C%20beautiful%20young%20couple%20in%20flower%20garden%2C%20soft%20pastel%20colors%2C%20romantic%20atmosphere%2C%20clean%20illustration%20with%20warm%20lighting%2C%20Korean%20digital%20art%20style%2C%20vertical%20webtoon%20cover%20design%2C%20elegant%20and%20dreamy%20aesthetic%20on%20simple%20light%20background&width=600&height=800&seq=comic-cover-01&orientation=portrait",
    rating: 9.5,
    status: "连载中",
    views: 1280000,
    updateDate: "2026-08-04",
    publishDate: "2025-03-15",
    tags: ["恋爱", "奇幻", "治愈", "校园"],
    summary: "平凡女大学生意外继承了祖母的秘密花园，在那里遇见了神秘又迷人的园丁，一段穿越时空的浪漫故事就此展开。这部作品以细腻的情感描绘和精美的画风，成为了韩国恋爱漫画中的现象级作品。",
    sections: [
      {
        heading: "故事背景与世界观",
        content: "《她的秘密花园》的故事发生在一个普通现代都市与神秘花园交织的世界中。主角金多美是一名平凡的大学生，某天收到了祖母去世后留给她的一把古老钥匙。这把钥匙打开了一扇通往神秘花园的门——一个时间流动与现实世界完全不同的异空间。花园中四季同时存在，每一朵花都承载着一个人的记忆与情感。作者金智媛通过这个设定，巧妙地将现实与奇幻融合，创造出一个既浪漫又充满想象力的叙事空间。",
      },
      {
        heading: "主要角色分析",
        content: "女主角金多美是一个性格内向但内心坚强的普通大学生。她的成长轨迹从最初的迷茫与不安，到逐渐发现自己的价值与使命，是整个故事的核心驱动力。男主角李贤宇是花园中的神秘园丁，外表冷漠但内心温暖，他的真实身份与花园的秘密紧密相连。两人的互动从最初的陌生与戒备，到逐渐理解与信任，情感发展自然而动人。配角群也十分出彩，多美的闺蜜智雅为故事增添了不少轻松元素，而反派角色朴室长的阴谋则为剧情增添了紧张感。",
      },
      {
        heading: "画风与艺术风格",
        content: "金智媛的画风以柔和的水彩风格为主，人物线条流畅优雅，背景描绘细腻而富有诗意。尤其是在描绘花园场景时，作者使用了大量花卉元素和光影变化，营造出梦幻般的视觉体验。色彩运用上以暖色调为主，粉色、金色和浅绿色的搭配让整个作品充满了温暖与治愈感。这种独特的艺术风格也是该作品能够脱颖而出的重要原因之一。",
      },
      {
        heading: "作品评价与影响力",
        content: "《她的秘密花园》自连载以来，在韩国主流漫画平台Naver Webtoon上获得了超过128万的阅读量，评分高达9.5分，是韩国恋爱漫画中评价最高的作品之一。读者普遍称赞这部作品的独特世界观设定和细腻的情感表达。许多读者表示，在阅读过程中不仅被浪漫的爱情故事所打动，更被作品中关于记忆、成长与告别的深刻主题所触动。该作品目前已有多语言翻译版本，在海外也拥有大量忠实读者。",
      },
      {
        heading: "推荐理由",
        content: "如果你喜欢治愈系的恋爱故事，如果你欣赏精美细腻的韩漫画风，如果你对奇幻与现实的交融感兴趣，那么《她的秘密花园》绝对不容错过。它不仅是一部优秀的韩国恋爱漫画，更是一部能触动心灵、引发思考的佳作。无论你是韩漫新手还是资深读者，这部作品都能给你带来独特的阅读体验。",
      },
    ],
    faqs: [
      {
        question: "《她的秘密花园》目前更新到第几话了？",
        answer: "截至2026年8月，《她的秘密花园》已更新至第128话，每周四更新。作者金智媛表示故事已进入后半段，预计总话数在150话左右完结。",
      },
      {
        question: "这部漫画适合什么年龄段的读者？",
        answer: "《她的秘密花园》适合15岁及以上的读者阅读。作品主题以恋爱和成长为主，内容温馨治愈，没有过于激烈的成人内容，属于全年龄段可放心阅读的韩国漫画佳作。",
      },
      {
        question: "在哪里可以阅读《她的秘密花园》？",
        answer: "《她的秘密花园》可在韩国Naver Webtoon平台阅读韩文原版，中文翻译版可在各大正版漫画平台上找到。我们推荐通过正规渠道支持作者。",
      },
    ],
  },
  7: {
    id: 7,
    title: "命运之轮",
    author: "韩智慧",
    category: "drama",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20style%20drama%20cover%2C%20elegant%20woman%20in%20traditional%20hanbok%20standing%20before%20palace%20gate%2C%20historical%20and%20emotional%20atmosphere%2C%20Korean%20digital%20painting%20style%2C%20warm%20and%20rich%20colors%2C%20cinematic%20composition%20on%20simple%20background&width=600&height=800&seq=comic-cover-07&orientation=portrait",
    rating: 9.6,
    status: "已完结",
    views: 2100000,
    updateDate: "2026-06-15",
    publishDate: "2023-09-01",
    tags: ["剧情", "历史", "爱情", "古装"],
    summary: "朝鲜王朝末期，贵族之女与平民画师之间跨越阶级的爱情故事，在动荡时代背景下谱写的悲欢离合。这部作品被誉为近年来最优秀的韩国漫画之一。",
    sections: [
      {
        heading: "时代背景与历史考据",
        content: "《命运之轮》的故事背景设定在19世纪末的朝鲜王朝，正值东西方文化碰撞、社会剧烈变革的时期。作者韩智慧在创作过程中进行了大量历史考据，从服饰、建筑、礼仪到社会制度，都力求还原那个时代的真实面貌。作品中出现的景福宫、北村韩屋村等场景都经过精心考证，让读者仿佛穿越回到那个风云变幻的年代。这种对历史细节的严谨态度，为整个故事奠定了坚实的基础。",
      },
      {
        heading: "主线剧情概述",
        content: "故事围绕贵族之女李素妍与平民画师金允浩之间的爱情展开。素妍出身两班贵族，从小接受严格的闺秀教育，但她内心渴望自由与艺术。允浩是一位才华横溢的画师，以描绘市井生活而闻名。两人在一次偶然的书画会上相识，从此命运紧密相连。然而，阶级的鸿沟、家族的反对、时代的动荡，都成为横亘在两人之间的巨大障碍。作品通过他们的爱情故事，展现了个人命运在时代洪流中的挣扎与抗争。",
      },
      {
        heading: "人物塑造与情感深度",
        content: "韩智慧笔下的人物形象饱满而真实。素妍不是传统意义上的柔弱女主角，她在爱情与家族责任之间做出的每一个选择都体现了她的独立思考与勇气。允浩则代表了那个时代追求艺术自由与人格尊严的平民知识分子形象。配角群体同样令人印象深刻——素妍的乳母韩尚宫、允浩的画友朴进士、以及开明派官员沈大人，每个人物都有自己的故事线和成长弧光，共同构成了一个丰富而立体的叙事网络。",
      },
      {
        heading: "艺术成就与社会影响",
        content: "《命运之轮》在韩国漫画界获得了空前的成功，总阅读量突破210万，评分9.6分高居韩国漫画排行榜榜首。作品不仅获得了2024年韩国漫画大赏最佳作品奖，还被改编为电视剧和音乐剧。评论家认为，这部作品成功地提升了韩国漫画的艺术水准，证明了漫画这一媒介完全能够承载严肃的历史题材和深刻的人性探讨。",
      },
      {
        heading: "推荐理由与阅读建议",
        content: "如果你喜欢历史题材的作品，如果你欣赏深刻动人的爱情故事，如果你对朝鲜王朝时期的文化感兴趣，那么《命运之轮》将带给你无与伦比的阅读体验。建议阅读时关注作者在每一话结尾处附上的历史小知识，这些内容能帮助你更好地理解故事背景。已完结的完整故事线也能让你享受一气呵成的阅读快感。",
      },
    ],
    faqs: [
      {
        question: "《命运之轮》已经完结了吗？总共多少话？",
        answer: "是的，《命运之轮》已于2026年6月正式完结，全作共156话，包含3话番外篇。完结后仍有大量读者在讨论结局，可见其影响力之大。",
      },
      {
        question: "这部作品的改编情况如何？",
        answer: "《命运之轮》已确认将被改编为电视剧，预计2027年播出。此外，韩国国立剧场也推出了同名音乐剧，在首尔、釜山等地巡演，获得了观众的高度评价。",
      },
    ],
  },
  14: {
    id: 14,
    title: "社长大人请自重",
    author: "宋多惠",
    category: "comedy",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20style%20comedy%20cover%2C%20funny%20office%20scene%20with%20serious%20boss%20and%20chaotic%20employee%2C%20bright%20and%20humorous%20atmosphere%2C%20Korean%20digital%20art%20style%2C%20colorful%20and%20playful%2C%20clean%20composition%20on%20simple%20light%20background&width=600&height=800&seq=comic-cover-14&orientation=portrait",
    rating: 9.3,
    status: "连载中",
    views: 1560000,
    updateDate: "2026-08-05",
    publishDate: "2024-06-20",
    tags: ["搞笑", "职场", "变身", "日常"],
    summary: "当完美主义的冷面上司意外变成了公司的吉祥物玩偶，小秘书不得不在保守秘密的同时应付各种爆笑状况。这部漫画以职场为背景，用幽默的方式探讨了现代职场人的工作与生活。",
    sections: [
      {
        heading: "故事设定与创意来源",
        content: "《社长大人请自重》的创意设定十分独特：韩国最大广告公司的社长车敏浩因一次神秘事件，每天下午三点到五点之间会变成公司的吉祥物——一只巨大的企鹅玩偶。这个设定既荒诞又充满可能性，为故事提供了取之不尽的喜剧素材。作者宋多惠在接受采访时表示，灵感来源于她对职场中权力关系的观察——如果高高在上的社长突然失去了所有权力象征，会发生什么有趣的事情？",
      },
      {
        heading: "角色介绍与人物关系",
        content: "男主角车敏浩（社长）是一个典型的完美主义者，对工作要求极其严格，在员工中有着冷面阎王的称号。然而变成企鹅玩偶后，他不得不依赖秘书安秀妍的帮助来掩盖真相。这种角色反转带来了大量喜剧效果——平时高高在上的社长现在必须听从秘书的安排，甚至被当成真正的玩偶被员工们随意摆布。女主角安秀妍是一个看似平凡但内心强大的职场女性，她在保守秘密的过程中逐渐发现了社长不为人知的温柔一面。",
      },
      {
        heading: "幽默风格与叙事特点",
        content: "宋多惠的幽默风格独树一帜，她擅长通过夸张的表情和肢体动作来制造笑点，同时又不会让角色显得过于卡通化。作品中的笑料大多来源于真实的职场场景——加班、会议、团建、年会等，让每一个经历职场生活的读者都能产生强烈的共鸣。尤其值得一提的是，作者在喜剧之外也穿插了温馨治愈的时刻，使得整个作品张弛有度，笑中带泪。",
      },
      {
        heading: "社会话题探讨",
        content: "《社长大人请自重》并非纯粹的搞笑漫画，它在嬉笑怒骂之间也探讨了多个严肃的社会话题：职场中的权力结构、工作与生活的平衡、女性在职场中的处境、以及人与人之间的理解与沟通。通过这些话题的探讨，作品超越了简单的搞笑漫画范畴，成为了一部有深度的职场题材作品。",
      },
      {
        heading: "推荐理由",
        content: "如果你正在经历职场生活的压力与烦恼，如果你想找一部能让人开怀大笑又能引人思考的漫画，《社长大人请自重》绝对是你的不二之选。它用幽默的方式治愈职场人的心灵，让我们在笑声中重新审视工作与生活的意义。",
      },
    ],
    faqs: [
      {
        question: "《社长大人请自重》每周什么时候更新？",
        answer: "该作品每周五更新，每次更新一话。作者宋多惠的更新非常稳定，几乎从不拖更，读者可以放心追更。",
      },
      {
        question: "这部漫画有动画化的计划吗？",
        answer: "据韩媒报道，《社长大人请自重》的动画改编项目正在洽谈中，但尚未有正式的官方公告。由于作品的人气和口碑都非常好，动画化的可能性很高。",
      },
    ],
  },
};

export function getArticleById(id: number): ArticleContent | undefined {
  return articleContents[id];
}